import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { isMobile } from '../_app/cuchillo/core/Basics';

export class ScrollItem__Default extends VScroll_Item {
  _displays = [];
  _titles = [];
  _circularTitle;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.setup();

    this.onShow = () => {
      this.triggerShow();
    }
    this.onHide = () => {
      this.triggerHide();
    }
    this.onMove = () => {
      this.triggerMove();
    }
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  setup() {
    this.setUpDisplays();
    this.setUpTitles();

    this._circularTitle = GetBy.class('__circular-title', this.item)[0];
  }

  triggerShow() {
    this.showDisplays();
    this.showTitles();
  }

  triggerHide() { }

  triggerMove() {
    if (this._circularTitle && !isMobile) {
      const p = Maths.clamp(Maths.map(1 - this.progressInside, 0, .3, 10, -6), -80, 80);
      this._circularTitle.style.setProperty('--rot-text', `${p}deg`);
    }
  }

  setUpDisplays() {
    const titles = GetBy.class('__display', this.item);

    if (titles.length === 0) return;

    for (let i = 0; i < titles.length; i++) {
      const title = titles[i];
      const word = new SplitText(title, {
        type: 'words'
      }).words;
      this._displays[i] = new SplitText(word, {
        type: 'chars',
        tag: 'span'
      }).chars;

      gsap.set(this._displays[i], { rotateY: '100deg', opacity: 0 });
    }
  }

  setUpTitles() {
    const titles = GetBy.class('__title', this.item);

    if (titles.length === 0) return;

    for (let i = 0; i < titles.length; i++) {
      const title = titles[i];
      const lines = new SplitText(title, {
        type: 'lines',
        linesClass: 'line-parent'
      }).lines;
      this._titles[i] = new SplitText(lines, {
        type: 'lines',
        tag: 'span'
      }).lines;

      gsap.set(this._titles[i], { y: '100%' });
    }
  }

  showDisplays() {
    for (let i = 0; i < this._displays.length; i++) {
      const title = this._displays[i];
      let delay = 0;

      for (let j = 0; j < title.length; j++) {
        const char = title[j];

        gsap.to(char, { rotateY: '0', duration: 2 + .1 * j, delay, ease: Ease.EASE_CUCHILLO_OUT });
        gsap.to(char, { opacity: 1, duration: .4, delay: delay + .2, ease: Power2.easeOut });

        delay += .02;
      }
    }
  }

  showTitles() {
    for (let i = 0; i < this._titles.length; i++) {
      const title = this._titles[i];
      let delay = 0;

      for (let j = 0; j < title.length; j++) {
        const line = title[j];
        gsap.to(line, { y: '0', duration: 1.2 + .1 * j, delay, ease: Ease.EASE_CUCHILLO_OUT });

        delay += .04;
      }
    }
  }
}

Scroll._registerClass('Default', ScrollItem__Default);
